export const getDate = (date?: string) =>
    date ? new Date(date).getTime() : NaN;
